import { Directive, HostListener, Output, EventEmitter } from '@angular/core';

@Directive( { 
    selector : '[keyEnter]'
})
export class KeyEnterDirective{
    @Output() keyEnter = new EventEmitter();

    //host = hosting element (i.e the div this directive is attached to)        
    @HostListener( 'keydown', [ '$event' ] ) KeyDownEvent( e ){
        if( e.keyCode === 13 ){
            this.keyEnter.emit(e);
        }
    }
} 

//Usage
//<input (keyEnter)="doSomething();" />
